import { useEffect } from "react";
import {matchPath, useLocation} from "react-router-dom";
import {routesMap} from "../routes/routesMap";

export function useSEO({ lang = "en" }) {
    const location = useLocation();

    const currentEntry = Object.entries(routesMap).find(([_, def]) =>
        matchPath(def.path[lang], location.pathname)
    );

    const [, currentRoute] = currentEntry || [];

    useEffect(() => {
        if (!currentRoute) return;

        const { title, description, ogImageURI } = currentRoute;
        const localizedTitle = title ? title[lang] : null;
        const localizedDescription = description ? description[lang] : null;
        const canonical = `${origin}${location.pathname}`;

        if (localizedTitle) document.title = localizedTitle;

        // Meta description
        let descTag = document.querySelector('meta[name="description"]');
        if (!descTag) {
            descTag = document.createElement("meta");
            descTag.setAttribute("name", "description");
            document.head.appendChild(descTag);
        }
        descTag.setAttribute("content", localizedDescription);

        // Canonical
        let linkTag = document.querySelector('link[rel="canonical"]');
        if (!linkTag) {
            linkTag = document.createElement("link");
            linkTag.setAttribute("rel", "canonical");
            document.head.appendChild(linkTag);
        }
        linkTag.setAttribute("href", canonical);

        // Open Graph
        const setMeta = (property, content) => {
            if (!content) return;
            let tag = document.querySelector(`meta[property="${property}"]`);
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("property", property);
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", content);
        };
        setMeta("og:title", localizedTitle);
        setMeta("og:description", localizedDescription);
        if (ogImageURI) setMeta("og:image", `${location.origin}${ogImageURI}`);

    }, [lang, location.origin, location.pathname, currentRoute]);
}